import React from 'react'
import LeftBar from '../../Components/LeftBar'
import Dashnav from '../../Components/Dashnav'
import RequiComp from './RequiComp'

function Requisitions() {
  return (
    <div className='mainContainer'>
        <LeftBar/>
        <div className='theMainContainer'>
            <Dashnav/>
            <RequiComp/>      
        </div>
    </div>
  )
}

export default Requisitions